import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Transfer,
  Col,
  Select,
  Form,
  Typography,
} from 'antd';
import Pagination from './Pagination';

const { Text } = Typography;

const isDev = process.env.NODE_ENV === 'development';

const PlainTransfer = ({
  dataSource: _dataSource,
  formItemName,
  label,
  rules,
  // nested,
  filterProp,
  pagination,
  callbackPagination,
  disabled,
  showSelectAll,
  ...restProps
}) => {
  const [targetKeys, setTargetKeys] = useState([]);
  const [currentData, setCurrentData] = useState([]);
  const [page, setPage] = useState(1);
  const [q, setQ] = useState();
  const ref = useRef();
  const form = Form.useFormInstance();
  const currentValue = Form.useWatch(formItemName, form);

  const render = (element) => ['id', 'clave', filterProp]
    .map((k, i) => (isDev && i === 0 ? 'ID: ' : '').concat(element[k] || ''))
    .filter((k) => k)
    .join(' - ');

  const dataSource = (_dataSource?.results || _dataSource).concat(currentData).map((item) => ({
    ...item,
    key: item.id,
    value: item.id,
    label: render(item),
  }));

  useEffect(() => {
    setTimeout(() => {
      if (!Array.isArray(_dataSource)) {
        const keys = form.getFieldValue(formItemName) || [];
        // para anexar a dataSource los objetos seleccionados inicialmente
        setCurrentData(keys.filter((e) => !_dataSource.results.some((e2) => e2.id === e.id)));
        const _keys = keys.map((e) => e?.id || e);
        form.setFieldsValue({ [formItemName]: _keys });
        setTargetKeys(_keys);
      } else {
        const _keys = form.getFieldValue(formItemName) || [];
        // remover keys que no se encuentren en dataSource
        const keys = _keys.filter((k) => dataSource.some((d) => d.id === k));
        form.setFieldValue(formItemName, keys);
        setTargetKeys(keys.map((e) => e?.id || e));
      }
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setTargetKeys(currentValue);
  }, [currentValue]);

  const handleChange = (_q) => {
    if (callbackPagination) {
      setQ(_q);
      clearTimeout(ref.current);
      ref.current = setTimeout(() => callbackPagination(page, _q), 2000);
      setPage(1);
    }
  };

  return (
    <>
      <Col xs={0} sm={0} md={24}>
        <Text style={{ color: '#000000DA' }}>
          {label}
        </Text>
        <Transfer
          titles={['Disponibles', 'Seleccionados']}
            // eslint-disable-next-line react/jsx-props-no-spreading
            // {...restProps}
          listStyle={{ minHeight: 400, overflowX: 'scroll' }}
          disabled={disabled}
          targetKeys={targetKeys}
          dataSource={dataSource}
          className="plain-transfer"
          render={(item) => item.label}
          showSelectAll={showSelectAll}
          filterOption={(input, opt) => opt.label?.toLowerCase().trim()
            .indexOf(input?.toLowerCase().trim()) >= 0}
          onChange={(keys) => {
            setTargetKeys(keys);
            const validKeys = keys
              .filter((k) => typeof k === 'number')
              .map((k) => parseInt(k, 10));
            form.setFieldsValue({ [`${formItemName}`]: validKeys });
          }}
          pagination={pagination}
          showSearch
          oneWay
        />
        {!pagination ? (
          <Pagination
            count={_dataSource?.count}
            page={page}
            setPage={setPage}
            callback={callbackPagination}
          />
        ) : (<br />)}
      </Col>
      <Col xs={24} sm={24} md={0}>
        <Form.Item
          name={formItemName}
          label={label}
          rules={rules}
        >
          <Select
            // eslint-disable-next-line react/jsx-props-no-spreading
            // {...restProps}
            disabled={disabled}
            showSearch
            mode="multiple"
            showArrow
            onSearch={handleChange}
            onClear={() => {
              handleChange(undefined);
              if (restProps.onClear) {
                restProps.onClear();
              }
            }}
            allowClear
            style={{ width: '100%' }}
            optionFilterProp="children"
            filterOption={(input, opt) => opt.children.toLowerCase()
              .indexOf(input.toLowerCase()) >= 0}
            onChange={(keys) => {
              setTargetKeys(keys.map((k) => k.toString()));
            }}
            onPopupScroll={(e) => {
              if (callbackPagination && dataSource.next) {
                const { scrollHeight, scrollTop, clientHeight } = e.target;
                if (scrollHeight - scrollTop === clientHeight
                  && scrollTop !== 0) {
                  setPage(page + 1);
                  callbackPagination(page + 1, q);
                }
              }
            }}
            options={dataSource}
          />
        </Form.Item>
      </Col>
    </>
  );
};

PlainTransfer.propTypes = {
  dataSource: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape()),
    PropTypes.shape(),
  ]).isRequired,
  rules: PropTypes.arrayOf(PropTypes.shape()),
  formItemName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  // nested: PropTypes.bool,
  filterProp: PropTypes.string,
  pagination: PropTypes.bool,
  callbackPagination: PropTypes.func,
  disabled: PropTypes.bool,
  showSelectAll: PropTypes.bool,
};

PlainTransfer.defaultProps = {
  rules: [],
  filterProp: 'descripcion',
  pagination: true,
  callbackPagination: null,
  disabled: false,
  showSelectAll: false,
};

export default PlainTransfer;
